import styles from "./styles.module.scss"
import MedicinesPage from "./widget";

export default MedicinesPage;
export {styles};